<igo-context-list
  [map]="map"
  (edit)="editContext()"
  (managePermissions)="managePermissions()"
  [isDesktop]="isDesktop()"
/>
